module.exports = __webpack_public_path__ + "media/assets/good_at/jquery-698271469870f9358bdb96de7dd2ee0d.png";